import { render, staticRenderFns } from "./KeywordMarketplace.vue?vue&type=template&id=37ac0c76&scoped=true&"
import script from "./KeywordMarketplace.vue?vue&type=script&lang=js&"
export * from "./KeywordMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./KeywordMarketplace.vue?vue&type=style&index=0&id=37ac0c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac0c76",
  null
  
)

export default component.exports